<template>
  <div :class="['header-container', {'cms-shadow': shadow}]">
    <centered-container class="left no-wrap" horizontal="left">
      <div v-if="leftArrow || left" @click="$emit('navigateLeft')">
        <cms-icon v-if="leftArrow" width="15" height="15">
          <icon-arrow />
        </cms-icon>
        <span v-if="left">{{left}}</span>
      </div>
    </centered-container>

    <div class="header-title">
      <slot>
        <div v-if="text" style="line-height=70px;">
          <div style="font-size:1.1rem;">{{text}}</div>
          <div style="font-size:0.8rem;" class="ellipsis">{{subheader}}</div>
        </div>
      </slot>
    </div>

    <centered-container class="right" :horizontal="'right'">
      <div v-if="rightArrow || right" @click="onRightClick">
        <span :class="{disabled:rightDisabled}" v-if="right">{{right}}</span>
        <cms-icon v-if="rightArrow" width="15" height="15">
          <icon-arrow />
        </cms-icon>
      </div>
    </centered-container>
  </div>
</template>

<script>
import arrowNav from "../icons/arrow-nav";

export default {
  name: "cms-header",
  components: {
    "icon-arrow": arrowNav,
  },
  props: {
    left: {},
    text: {},
    right: {},
    leftArrow: {
      default: false,
    },
    rightArrow: {
      default: false,
    },
    rightDisabled: {
      default: false,
    },
    subheader: {
      default: null,
    },
    shadow:{
      default: true
    }
  },
  methods: {
    onRightClick() {
      if (!this.rightDisabled) {
        this.$emit("navigateRight");
      }
    },
  },
};
</script>

<style scoped lang="scss">
div {
  padding-left: 0;
  padding-right: 0;
}

.header-container {
  display: flex;
  height: 100%;
  
  &.cms-shadow{
    box-shadow: rgb(193, 198, 201) 0px 2px 3px 0px;
  }
}

.header-title {
  justify-content: center;
  width: 50%;
  display: flex;
  height: 100%;
  flex-direction: column;
}

.left,
.right {
  width: 25%;
}

.left {
  padding-left: 0.6rem;
}

.left svg {
  transform: rotate(180deg);
}

.right {
  padding-right: 0.6rem;
}

span.disabled {
  opacity: 0.5;
}

.center {
  width: 50%;
}
</style>
